export default {
  methods: {
    sendAnalytics() {
      if (process.browser && typeof this.$gtag !== 'undefined') {
        let price = this.totalAmount
        if (this.promotions.length > 0) {
          const isCurrentPromotion =
            Date.parse(this.promotions[0].end) >= Date.now()

          if (this.promotions[0].rules.length > 0) {
            price = this.promotions[0].rules[0].condition.includes(
              this.currency
            )
              ? this.totalAmount * (1 - this.promotions[0].value / 100)
              : this.totalAmount
          } else if (isCurrentPromotion) {
            price = this.totalAmount * (1 - this.promotions[0].value / 100)
          }
        }
        this.$gtag('event', 'view_item', {
          items: [
            {
              id: this.exExperience.uuid,
              name: this.exExperience.name,
              list_position: 1,
              quantity: 1,
              price: price.toFixed(2).toString(),
              currency: this.currency,
            },
          ],
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
        this.$gtag('event', 'eec.productDetail', {
          ecommerce: {
            detail: {
              products: [
                {
                  name: this.exExperience.name,
                  id: this.exExperience.uuid,
                  price: price.toFixed(2).toString(),
                },
              ],
            },
          },
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })

        const params = {
          content_type: 'destination',
          content_ids: this.exExperience
            .uuid /** specific to the top 3-5 destinations listed in search results */,
          travel_start: null /** solo aplica cuando hay filtro de rango de fecha */,
          travel_end: null /** solo aplica cuando hay filtro de rango de fecha */,
          city: this.exExperience
            .starting_point /** solo aplica cuando se busca por ciudad */,
          region: null /** region or state => no aplica de momento */,
          country: this.exExperience.country
            .name /** se obtiene del primer item */,
          num_adults: 1,
          num_children: null /** if applicable> */,

          content_name: this.exExperience.name,
          value: this.totalAmount,
          currency: this.currency,
        }

        Object.keys(params)
          .filter((t) => !params[t])
          .map((t) => delete params[t])

        if (typeof this.$fb !== 'undefined') {
          this.$fb.track('ViewContent', params)
        }
      }
    },
  },
}
